//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "CurrentDialog",
  props: {
    // 弹窗是否显示
    showDialog: {
      type: Boolean,
      default: false,
    },
    // 弹窗信息
    dialogObj: {
      type: Object,
      default: {},
    },
    // 区域树形结构数据
    businessZoneList: {
      type: Array,
      default: [],
    },
    // 当前节点数据
    areaData: {
      type: Object,
      default: {},
    },
    // 表格选中数据
    multipleSelection: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentForm: {}, // 当前表单提交参数
      currentRules: {}, // 当前表单验证
      // 不同表单对应绑定数据
      formObj: {
        1: {
          orderNum: 4,
          menuLevel: 1,
          menuIsChild: 1,
          zoneName: "",
          parentId: null,
        },
        2: {
          orderNum: 4,
          menuLevel: 1,
          menuIsChild: 1,
          zoneName: "",
          parentId: null,
        },
        3: {
          zoneName: "",
          id: "",
        },
        4: {
          ids: [],
          businessZoneId: "",
        },
        5: {
          id: "",
        },
      },
      node: {}, // 选择区域  选中节点
      areaPersonList: [], // 增加业务员列表
      keyWord: "", // 搜索关键字
      dutyPersonList: [], //
      dutyIds: [], // 新增业务员id集合
      dutyCheckeds: [], // 设置负责人人员列表
      optionPersonList: [], // 更换业务员列表
    };
  },
  computed: {
    // 展示表单项
    showItem() {
      return (id, type) => {
        let ids = {
          name: [1, 2, 3],
          select: [1, 2],
          form: [1, 2, 3],
          delete: [5, 10],
          person: [4, 8],
          change: [9],
        };
        return ids[type].includes(id);
      };
    },
    // 新增业务员列表过滤掉当前业务员
    optionList() {
      return (list, id) => {
        return list.filter((item) => {
          return item.id != id;
        });
      };
    },
  },
  methods: {
    /**
     * @description: 初始化数据
     * @Author: yangsibo
     * @Date: 2022-05-12 17:49:54
     */
    initData(val) {
      this.currentForm = this.formObj[val.id];
      switch (val.id) {
        case 1:
          this.currentForm.orderNum = this.businessZoneList
            ? this.businessZoneList.length + 1
            : 1;
          break;
        case 2:
          this.currentForm.orderNum = this.areaData.orderNum;
          this.currentForm.parentId = this.areaData.id;
          this.node = this.areaData;
          this.$nextTick(() => {
            this.$refs.selectedTree.setCurrentKey(this.node.id);
          });
          break;
        case 3:
          Object.assign(this.currentForm, this.areaData);
          break;
        case 4:
          this.specifiedDutyList(this.areaData.id);
          this.currentForm.businessZoneId = this.areaData.id;
          break;
        case 5:
          this.currentForm.id = this.areaData.id;
          break;
        case 8:
          this.addPersonList(this.areaData.id);
          break;
        default:
          break;
      }
    },
    /**
     * @description: 关闭弹窗
     * @Author: yangsibo
     * @Date: 2022-05-13 14:19:50
     */
    close() {
      this.$emit("close");
    },
    /**
     * @description: 保存当前表单
     * @Author: yangsibo
     * @Date: 2022-05-13 08:50:05
     */
    confirmCurrent() {
      switch (this.dialogObj.id) {
        case 1:
        case 2:
          this.insertMBusinessZone();
          break;
        case 3:
          this.updateMBusinessZoneNameById();
          break;
        case 4:
          this.specifiedDuty(this.getParams(4));
          break;
        case 5:
          this.deleteMBusinessZoneNameById();
          break;
        case 8:
          this.batchAddPerson(this.getParams(8));
          break;
        case 10:
          this.batchDelPerson(this.multipleSelection);
          break;
        default:
          break;
      }
    },
    /**
     * @description: 获取参数集合
     * @Author: yangsibo
     * @Date: 2022-05-16 10:07:10
     * @param {*} id 类型
     * @return {*}
     */
    getParams(id) {
      if (id == 8) {
        return {
          manageDtos: this.dutyCheckeds,
          businessZoneId: this.areaData.id,
        };
      }
      if (id == 4) {
        return {
          ids: this.dutyIds,
          businessZoneId: this.areaData.id,
        };
      }
    },
    /**
     * @description: 新增业务区域
     * @Author: yangsibo
     * @Date: 2022-05-13 10:24:16
     */
    async insertMBusinessZone() {
      if (!this.currentForm.zoneName) {
        this.$message({
          type: "warning",
          message: "请输入区域名称",
          duration: 2000,
        });
        return false;
      }
      try {
        let { status } = await this.$http.business.insertMBusinessZone(
          this.currentForm
        );
        if (status === "1") {
          this.confirmEnd("新增业务区域成功");
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * @description: 修改区域名称
     * @Author: yangsibo
     * @Date: 2022-05-13 15:00:06
     */
    async updateMBusinessZoneNameById() {
      if (!this.currentForm.zoneName) {
        this.$message({
          type: "warning",
          message: "请输入区域名称",
          duration: 2000,
        });
        return false;
      }
      try {
        let { status } = await this.$http.business.updateMBusinessZoneNameById(
          this.currentForm
        );
        if (status === "1") {
          this.confirmEnd("修改名称成功");
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * @description: 根据id删除业务区域
     * @Author: yangsibo
     * @Date: 2022-05-13 15:25:24
     */
    async deleteMBusinessZoneNameById() {
      try {
        let { status } = await this.$http.business.deleteMBusinessZoneNameById(
          this.currentForm
        );
        if (status === "1") {
          this.confirmEnd("删除区域成功");
        }
      } catch (error) {}
    },
    /**
     * @description: 获取区域成员列表
     * @Author: yangsibo
     * @Date: 2022-05-13 16:38:31
     */
    async specifiedDutyList(businessZoneId) {
      try {
        let { data } = await this.$http.business.specifiedDutyList({
          businessZoneId,
        });
        let duty = data
          .map((val) => {
            if (val.dutyFlag) {
              return val.id;
            }
          })
          .filter((val) => {
            return val;
          });

        this.dutyIds = duty;
        this.dutyCheckeds = data.filter((val) => {
          return val.dutyFlag;
        });
        this.areaPersonList = data;
      } catch (error) {}
    },
    /**
     * @description: 设置负责人
     * @Author: yangsibo
     * @Date: 2022-05-13 17:16:55
     */
    async specifiedDuty(params) {
      try {
        let { status } = await this.$http.business.specifiedDuty(params);
        if (status === "1") {
          this.confirmEnd("设置负责人成功");
          this.areaData.flag = true;
          this.$emit("handleNodeClick", this.areaData);
        }
      } catch (error) {}
    },
    /**
     * @description: 添加业务员回显
     * @Author: yangsibo
     * @Date: 2022-05-16 08:48:04
     */
    async addPersonList(businessZoneId, callback) {
      try {
        let { data } = await this.$http.business.addPersonList({
          businessZoneId,
        });
        this.dutyPersonList = data ? data : [];
        callback && callback(data);
      } catch (error) {}
    },
    /**
     * @description: -批量添加业务员
     * @Author: yangsibo
     * @Date: 2022-05-16 10:04:32
     */
    async batchAddPerson(params) {
      try {
        let { status } = await this.$http.business.batchAddPerson(params);
        if (status === "1") {
          this.confirmEnd("添加业务员成功");
          this.$emit("getPersonListbyZoneId", this.areaData.id);
        }
      } catch (error) {}
    },
    /**
     * @description: 批量删除业务员
     * @Author: yangsibo
     * @Date: 2022-05-16 10:16:30
     * @param {*} ids 需要被删除的业务员集合
     * @return {*}
     */
    async batchDelPerson(ids) {
      ids = ids.map((item) => {
        return item.id;
      });
      try {
        let { status } = await this.$http.business.batchDelPerson({ ids });
        if (status === "1") {
          this.confirmEnd("删除业务员成功");
          this.$emit("getPersonListbyZoneId", this.areaData.id);
        }
      } catch (error) {}
    },
    /**
     * @description: 确认 结束
     * @Author: yangsibo
     * @Date: 2022-05-13 15:03:23
     * @param {*} tip 提示文案
     */
    confirmEnd(message) {
      this.$message({
        type: "success",
        message,
        duration: 2000,
      });
      this.$emit("close");
      this.$emit("getBusinessZoneList", () => {
        this.$nextTick(() => {
          this.$parent.$refs["my-tree"].setCurrentKey(this.areaData.id);
        });
      });
    },
    /**
     * @description: 选中树
     * @Author: yangsibo
     * @Date: 2022-05-13 09:32:58
     */
    handleNodeClick(data, checked) {
      if (checked) {
        this.node = data;
        this.currentForm.parentId = data.id;
        this.currentForm.orderNum = data.children
          ? data.children.length + 1
          : 1;
        this.$refs.selectTree.blur();
        this.$nextTick(() => {
          this.$refs.selectedTree.setCurrentKey(this.node.id);
        });
      }
    },

    /**
     * @description: 查询人员
     * @Author: yangsibo
     * @Date: 2022-05-13 17:51:16
     */
    handleFilter() {
      this.addPersonList(this.areaData.id, (data) => {
        this.dutyPersonList = data.filter((item) => {
          return item.fullName.includes(this.keyWord);
        });
      });
    },
    /**
     * @description: 添加业务员多选款变化
     * @Author: yangsibo
     * @Date: 2022-05-16 10:03:15
     * @param {*} value 选中值
     * @return {*}
     */
    changeDutyList(value) {
      this.dutyCheckeds = this.dutyPersonList.filter((item) => {
        return value.includes(item.id);
      });
    },
    /**
     * @description: 添加业务员多选款变化
     * @Author: yangsibo
     * @Date: 2022-05-16 10:03:15
     * @param {*} value 选中值
     * @return {*}
     */
    changeIds(value) {
      this.dutyCheckeds = this.areaPersonList.filter((item) => {
        return value.includes(item.id);
      });
    },
    /**
     * @description: 删除数组中的某个元素
     * @Author: yangsibo
     * @Date: 2022-04-07 14:24:25
     * @param {*} i 删除元素的下标
     * @param {*} arr 需要删除元素的数组
     */
    deleteItem(i, arr, item) {
      arr.splice(i, 1);
      this.dutyIds = this.dutyIds.filter((val) => {
        return val != item.id;
      });
    },
  },
  created() {},
  mounted() {
    this.initData(this.dialogObj);
  },
  watch: {
    dialogObj: {
      handler(val) {
        this.initData(val);
      },
      deep: true,
    },
  },
};
